// Module
var code = "<span *ngIf=\"actionCounter?.expiredCount\" class=\"float-right badge badge-danger mx-1\">{{actionCounter.expiredCount}}</span> <span *ngIf=\"actionCounter?.todoCount\" class=\"float-right badge badge-warning mx-1\">{{actionCounter.todoCount}}</span>";
// Exports
module.exports = code;